import { useRef, useState } from 'react';
import { css } from 'linaria';
import { LISTEN_SPEEDS } from 'common/constants';
import { ListenIcon } from 'components/icons/ListenIcon';
const audioStyles = "awk7c15";
export const Audio = ({
  url,
  playEvent,
  pauseEvent,
  rateChangeEvent,
  endEvent
}) => {
  const ref = useRef();
  const [playbackSpeed, setPlaybackSpeed] = useState(1);

  const onPlay = () => playEvent();

  const onPause = () => pauseEvent();

  const onRateChange = e => rateChangeEvent(e.target.playbackRate);

  const onEnded = () => endEvent();

  const updatePlayback = e => {
    setPlaybackSpeed(e.target.value);
    ref.current.playbackRate = e.target.value;
  };

  return <div className={audioStyles}>
      <ListenIcon />
      <audio ref={ref} src={url} onPlay={onPlay} onPause={onPause} onRateChange={onRateChange} onEnded={onEnded} controls />
      <select value={playbackSpeed} onChange={updatePlayback}>
        {LISTEN_SPEEDS.map(val => <option value={val} key={val}>{val}x</option>)}
      </select>
    </div>;
};
Audio.defaultProps = {
  url: null,
  playEvent: () => {},
  pauseEvent: () => {},
  rateChangeEvent: () => {},
  endEvent: () => {}
};

require("./audio.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./audio.js");